import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter";

const Container = styled.div`
  font-weight: var(--font-weight-sm);
  font-size: var(--font-size-sm);
  color: ${({theme}) => theme.mainTextColor};

  h4{
    font-weight: var(--font-weight-lg);
    font-size: var(--font-size-sm);
    color: ${({theme}) => theme.mainTextColor};
  }

.list{
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 30px;
  width: 70%;
  gap: 10px;

  .list-item{
    display: flex;
    flex-direction: column;
  }
}

  .seperator{
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.contrastBorderColor};
  }
`

const OdemeDetails = ({odemeData}) => {
  return (
    <Container>
      {
        (odemeData?.hedefNakliyefiyat || odemeData?.odemeSekli?.value || odemeData?.yakitOrani || odemeData?.komisyonMiktari) &&
        <>
          <h4 className="title">Ödeme</h4>
          <div className="list">
              {
                odemeData?.hedefNakliyefiyat &&
                <div className="list-item">{formatConverter(odemeData?.hedefNakliyefiyat, 0)}{odemeData?.hedefNakliyefiyat && (odemeData?.fiyatYayinlansin ? "(Yayınlanacak)" : "(Yayınlanmayacak)")}</div>
              }
                <div className="list-item">{odemeData?.odemeSekli?.text}</div>
              <div className="list-item">{odemeData?.yakitOrani && `%${odemeData?.yakitOrani} Yakıt`}</div>
              {
                (odemeData?.komisyonMiktari && odemeData?.komisyonDurumu?.value) &&
                <div className="list-item">{odemeData?.komisyonDurumu?.value === 2 && "%"}{formatConverter(odemeData?.komisyonMiktari, 0)}{odemeData?.komisyonDurumu?.value === 1 && " TL"} Komisyon</div>
              }
          </div>
        </>
      }
    </Container>
  )
}

export default OdemeDetails